export default "__VITE_ASSET__DCQI0Rf3__"